import {
  REDUX_HIDE_SAMPLE_GENERATION_LIMIT_POPUP,
  REDUX_HIDE_SAMPLE_READ_ONLY_POPUP,
  REDUX_SHOW_SAMPLE_GENERATION_LIMIT_POPUP,
  REDUX_SHOW_SAMPLE_READ_ONLY_POPUP,
} from '../Actions/SampleReadOnly/ActionTypes/ReduxActionTypes'

export type SampleReadOnlyReducer = {
  /** Whether the "Try generating a sample timetable first" popup is open. */
  showPopup: boolean
  /** Whether the "sample timetable generation limit reached" modal is open. */
  showLimitPopup: boolean
}

const initialState: SampleReadOnlyReducer = {
  showPopup: false,
  showLimitPopup: false,
}

export default function sampleReadOnlyReducer(
  state = initialState,
  action: {type: string}
): SampleReadOnlyReducer {
  switch (action.type) {
    case REDUX_SHOW_SAMPLE_READ_ONLY_POPUP:
      return {...state, showPopup: true}
    case REDUX_HIDE_SAMPLE_READ_ONLY_POPUP:
      return {...state, showPopup: false}
    case REDUX_SHOW_SAMPLE_GENERATION_LIMIT_POPUP:
      return {...state, showLimitPopup: true}
    case REDUX_HIDE_SAMPLE_GENERATION_LIMIT_POPUP:
      return {...state, showLimitPopup: false}
    default:
      return state
  }
}
